import { inject } from '@angular/core';
import {
  patchState,
  signalStore,
  withMethods,
  withState,
} from '@ngrx/signals';
import { ChatMessage } from './chat.types';
import { ChatService } from './chat.service';
import { withStorageSync } from '@angular-architects/ngrx-toolkit';
import { v4 } from 'uuid';
type ChatState = {
  chats: { 
    chatId: string, 
    groupId: string, 
    isLoading:boolean,
    title: string, 
    messages: ChatMessage[] 
  }[];
};

const initialState: ChatState = {
  chats: [],
};

export const ChatStore = signalStore(
  { providedIn: 'root' },

  withState(initialState),

  // withStorageSync({
  //   key: 'chat-store',
  //   autoSync: true,
  //   select: ((state: ChatState) => ({
  //     chats: state.chats,
  //   })) as (state: any) => Partial<any>,
  // }),

  // const msgs = result.messages.map(m=>({
  //   ...m,
  //   isMine:m.senderId==user?.id?true:false,
  //   senderName:members?.find(member=>member.userId==m.senderId)?.name,
  // }));


  withMethods((store, service = inject(ChatService)) => ({

    async loadChatMessages(props:{chatTitle:string,groupId:string,chatId:string,weekSpan:number}): Promise<boolean> {
      
      //Updates the loading indicator, if necessary, create a new chat entry
      let chatIndex = store.chats().findIndex(
        c => c.chatId === props.chatId && c.groupId === props.groupId
      );

      if (chatIndex === -1) {
        patchState(store, {
          chats: [
            ...store.chats(),
            {
              chatId:props.chatId,
              groupId:props.groupId,
              isLoading: true,
              title: props.chatTitle,
              messages: [],
            },
          ],
        });
      } else {
        patchState(store, {
          chats: store.chats().map((chat, idx) =>
            idx === chatIndex
              ? { ...chat, isLoading: true }
              : chat
          ),
        });
      }

      //Now load (or reload) the chat messages. 
      //NEXT STEP=> check the existing cached messages against the server version of them, reloading only the ones that are not in the cache

      const messages = await service.loadChatMessages({groupId:props.groupId, chatId:props.chatId});
      if (messages) {
        chatIndex = store.chats().findIndex(
          c => c.chatId === props.chatId && c.groupId === props.groupId
        );

        //If messages are returned, we can update the chat
        patchState(store, {
          chats: store.chats().map((chat, idx) =>
            idx === chatIndex
              ? { ...chat, isLoading: false, messages:messages }
              : chat
          ),
        });
        console.log(store.chats());
        return true;
      }else{
        //If no messages are returned, we can assume the chat is empty
        patchState(store, {
          chats: store.chats().map((chat, idx) =>
            idx === chatIndex
              ? { ...chat, isLoading: false, messages:[] }
              : chat
          ),
        });
        return false;
      }
    },
    
    async sendMessage(props:{groupId:string, chatId:string, senderId:string, content: string, replyToId?: string}) {

      const chatIndex = store.chats().findIndex(
        c => c.chatId === props.chatId && c.groupId === props.groupId
      );

      if (chatIndex === -1) {
        throw new Error('The chat must be loaded before sending a message');
      }

      const tempId = v4();
      const tempMessage = {
        id: tempId,
        userId: props.senderId,
        createdAt: new Date(),
        content: props.content,
        isMine: true,
        error: false,
      } as ChatMessage;

      //Push the temporary message to the chat
      patchState(store, {
        chats: store.chats().map((chat, idx) =>
          idx === chatIndex
            ? { ...chat, messages: [...chat.messages, tempMessage]}
            : chat
        ),
      });

      //Tries to send the message
      let sent=false;
      try{
        const sent = await service.sendChatMessage({groupId:props.groupId, chatId:props.chatId, content:props.content});
      }catch(e){
        console.error('Error sending message', e);
      }
        //Handle error
      if(!sent){
        //mark the message as error
        patchState(store, {
          chats: store.chats().map((chat, idx) =>
            idx === chatIndex
              ? {
                  ...chat,
                  messages: chat.messages.map(m =>
                    m.id === tempId ? { ...m, error: true } : m
                  ),
                }
              : chat
          ),
        });
      }

    },

  //   updateMessageCache(messageId:string,groupId:string,chatId:string, userId: string, date: string, content: string) {
  //     if(store.chatCache().find(c=>c.chatId==chatId && c.journeyId==journeyId)){
  //       const members = gjStore.groupJourneys().find(j=>j.id==journeyId)?.members;        

  //       const msg = {
  //         id: id,
  //         senderId: userId,
  //         dateTime: date,
  //         content: content,
  //       } as JourneyChatMessage;

  //       patchState(store, {
  //         chatCache: store.chatCache().map(chat => (
  //           chat.chatId == chatId && chat.journeyId == journeyId ?
  //             {
  //               ...chat, messages: [...chat.messages.filter(cm=>cm.id!=id), {...msg,
  //                 isMine:msg.senderId==userId?true:false,
  //                 senderName:members?.find(member=>member.userId==msg.senderId)?.name
  //               }]
  //             } : chat
  //         ))
  //       });
  //     }
  //   },
  }))
);



